<template>
  <div class="c-main">
    <h2 class="c-title c-title--page">{{ $t('event.login') }}</h2>

    <div class="c-tabs c-main">
      <div class="c-tab__tab-bar u-margin-bottom-medium">
        <router-link v-for="tab in $options.tabs" :key="tab.key" exact
                     class="c-button c-button--large c-button--ghost c-tabs__tab-link" :to="tab.route">
          {{ $t(tab.label) }}
        </router-link>
      </div>
      <div class="c-tabs__panel c-main">
        <router-view :key="this.$route.fullPath"></router-view>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "EventAccess",
  tabs: [
    { key: 'config', route: {name: 'event.access-config'}, label: 'config' },
    { key: 'display', route: {name: 'event.login', params: { type: 'display'}}, label: 'display' },
    { key: 'judge', route: {name: 'event.login', params: { type: 'judge'}}, label: 'judge.console' },
    { key: 'supervisor', route: {name: 'event.login', params: { type: 'supervisor'}}, label: 'supervisor' },
    { key: 'observer', route: {name: 'event.login', params: { type: 'observer'}}, label: 'cis' },
  ],
  data: function() {
    return {}
  },
}
</script>

<style scoped>
</style>
